import React, { Component, createRef } from 'react'
import { Link } from 'react-router-dom'

import { initAoxInViewport, destroyAoxInViewport } from '../../utilities/FrontFunctions/AoxInViewportClass'

import '../../../src/assets/css/0020_objects/1030_obj_push.css'
import '../../../src/assets/css/0010_sections/0510_section_services.css'


class SectionServices2026 extends Component {
    constructor(props) {
        super(props)
        
        this.sectionRef = createRef()
        this.viewportObserver = null

        this.state = {
        }
    }
    componentDidMount() {
        this.viewportObserver = initAoxInViewport({
            element: this.sectionRef.current,
            threshold: 0.2,
            rootMargin: '0px 0px -80px 0px',
            once: true,
            onEnter: () => {
                this.setState({ isVisible: true })
            }
        })
    }

    componentWillUnmount() {
        destroyAoxInViewport(this.viewportObserver)
    }


    render() {
        const { isVisible } = this.state
		const {scDatas, apiDatas} = this.props;

        return (
            <section ref={this.sectionRef} className={`obj_section section_services ${isVisible ? 'is-visible' : ''}`}>
            
                <div className='ctn_section-header'>
                    <div className="obj_text">
                        <div className="ctn_text-header animation_reveal-item animation_reveal--fade-up animation_delay-1">
                            <h2 className="t_title">Mes services Partner Academy</h2>
                        </div>
                    </div>
                </div>

                <div className='ctn_section'>

                    {scDatas && apiDatas.User && scDatas.PageEvents?.url &&
                        <div className={`obj_push push--services-pa animation_reveal-item animation_reveal--fade-up animation_delay-3`}>
                            <Link to={scDatas.PageEvents.url}>
                                <div className='ctn_push'>
                                    <div className="obj_text">
                                        <div className="ctn_text-header">
                                            <h3 className="t_title">Mes événements</h3>
                                        </div>
                                        <div className="ctn_text">
                                            <p className={`t_tag ${apiDatas.User?.Event_NbRegistered > 0 ? 'is_active' : ''}`}>
                                                <span>
                                                    {   
                                                        apiDatas.User?.Event_NbRegistered <= 0 ? <span>Pas d'événement</span>
                                                        : apiDatas.User.Event_NbRegistered === 1 ? <span>{apiDatas.User.Event_NbRegistered} événement à venir</span>
                                                        : <span>{apiDatas.User.Event_NbRegistered} événements à venir</span>
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className='ctn_background'>
                                    <div className='obj_image image_cover'>
                                        <picture className='ctn_image fade-in'>
                                            <img src={require('../../assets/images/v_push-services-pa1.png')} alt="Mes événements"/>
                                        </picture>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    }

                    {scDatas && apiDatas.User && scDatas.PageChallenges?.url && apiDatas.User.IsChallenge &&
                        <div className={`obj_push push--services-pa animation_reveal-item animation_reveal--fade-up animation_delay-4`}>
                            <Link to={scDatas.PageChallenges.url}>
                                <div className='ctn_push'>
                                    <div className="obj_text">
                                        <div className="ctn_text-header">
                                            <h3 className="t_title">Mes Challenges</h3>
                                        </div>
                                        <div className="ctn_text">
                                            { (apiDatas.User.Participation_NbToDeclare + apiDatas.User.Participation_NbToDisPatch === 0) ? 
                                                <p className="t_tag"><span>Pas de challenges</span></p>
                                            : <>
                                                {apiDatas.User.Participation_NbToDeclare > 0 && 
                                                    <p className="t_tag is_active">
                                                        <span>{apiDatas.User.Participation_NbToDeclare} challenge{apiDatas.User.Participation_NbToDeclare > 1 ? 's' : ''} à déclarer</span>
                                                    </p>
                                                }
                                                {apiDatas.User.Participation_NbToDisPatch > 0 && 
                                                    <p className="t_tag is_active">
                                                        <span>{apiDatas.User.Participation_NbToDisPatch} challenge{apiDatas.User.Participation_NbToDisPatch > 1 ? 's' : ''} à répartir</span>
                                                    </p>
                                                }
                                            </> }
                                        </div>
                                    </div>
                                </div>

                                <div className='ctn_background'>
                                    <div className='obj_image image_cover'>
                                        <picture className='ctn_image fade-in'>
                                            <img src={require('../../assets/images/v_push-services-pa2.png')} alt="Mes Challenges"/>
                                        </picture>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    }

                    {scDatas && apiDatas.User && scDatas.PageExpertise?.url &&
                        <div className={`obj_push push--services-pa animation_reveal-item animation_reveal--fade-up animation_delay-5`}>
                            <Link to={scDatas.PageExpertise.url}>
                                <div className='ctn_push'>
                                    <div className="obj_text">
                                        <div className="ctn_text-header">
                                            <h3 className="t_title">Mon expertise</h3>
                                        </div>
                                        <div className="ctn_text">
                                        </div>
                                    </div>
                                </div>

                                <div className='ctn_background'>
                                    <div className='obj_image image_cover'>
                                        <picture className='ctn_image fade-in'>
                                            <img src={require('../../assets/images/v_push-services-pa3.png')} alt="Mes Expertise"/>
                                        </picture>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    }
                </div>

            </section>
        )
    }
}

export default SectionServices2026